import { ReservationOccasion } from '../../../../../services/exports/Constants';

export default {
  updated_details: 'Zaktualizowane szczegóły',
  previous_details: 'Poprzednie szczegóły',
  fields: {
    datetime: 'Data:',
    email: 'E-mail:',
    phone_number: 'Numer telefonu:',
    customer: 'Klient:',
    source: 'Źródło:',
    guests: 'Goście:',
    comment: 'Komentarz:',
    confirmed_at: 'Potwierdzone o:',
    status: 'Status:',
    occasion: 'Okazja:',
    created_at: 'Utworzono o:',
  },
  status: {
    confirmed: 'Potwierdzone',
    pending: 'Oczekuje na zatwierdzenie',
    canceled: 'Anulowane',
    canceled_by_customer: 'Anulowane przez klienta',
    rejected: 'Odrzucone',
    removed: 'Usunięte',
  },
  buttons: {
    confirm: 'Potwierdź',
    reject: 'Odrzuć',
    cancel: 'Anuluj',
    edit: 'Edytuj',
    remove: 'Usuń',
  },
  occasion: {
    [ReservationOccasion.Birthday]: 'Urodziny',
    [ReservationOccasion.Anniversary]: 'Rocznica',
    [ReservationOccasion.Date]: 'Randka',
    [ReservationOccasion.SpecialOccasion]: 'Specjalna okazja',
    [ReservationOccasion.BusinessMeal]: 'Posiłek służbowy',
  },
  remove_reservation_modal: {
    title: 'Czy na pewno chcesz usunąć rezerwację?',
    buttons: {
      remove: 'Usuń',
      cancel: 'Anuluj',
    },
  },
  response_messages: {
    success: 'Status rezerwacji zaktualizowany pomyślnie. Klient został powiadomiony.',
    error: 'Aktualizacja statusu rezerwacji nie powiodła się. Spróbuj ponownie.',
  },
};
